import { languageMap } from ".."

languageMap.cooklang = {
	comments: {
		line: "--",
		block: ["[-", "-]"],
	},
}
